import Navigation from '../components/Navigation';
import FishIcon from '../components/icons/FishIcon';
import HomeIcon from '../components/icons/HomeIcon';
import CalendarWhite from '../components/icons/CalendarWhite';
import ElementEqualIcon from '../components/icons/ElementEqualIcon';
import BookOpenWhite from '../components/icons/BookOpenWhite';
import UsersIcon from '../components/icons/UsersIcon';
import HeartIcon from '../components/icons/HeartIcon';
import HelpIcon from '../components/icons/HelpIcon';
import { useLocation } from 'react-router-dom';
import { fetchUserProfile } from '../utilities/api';
import { useEffect, useState } from 'react';
// import {DisciplineAbstainIcon} from '/media/images/discipline_abstain.svg';

function SidebarLeft() {

  const [user, setUser] = useState({ fullName: "", shortName: "" });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    const loadUser = async () => {
      try {
        const profile = await fetchUserProfile();

        if (profile.fullName && profile.shortName) {
          setUser(profile);
        } else {
          console.warn(" Empty profile received. Check API response.");
        }

        setIsLoading(false);
      } catch (error) {
        console.error(" Error loading user:", error);
        setIsLoading(false);
      }
    };

    loadUser();
  }, []); //  Runs only once on mount




  const location = useLocation();

  const sidebarClass = `hidden md:block sticky top-0 w-full h-full md:max-w-[30%] ${location.pathname === '/single-day' ? 'lg:max-w-[30%]' : 'lg:max-w-[22%]'} xl:max-w-17`;

  const navigationItems = [
    { label: 'Home', href: '/', Icon: HomeIcon },
    { label: 'Calendar', href: '/calendar', Icon: CalendarWhite },
    { label: 'Culture & Customs', href: '/culture-and-customs', Icon: ElementEqualIcon },
    { label: 'Prayer & Rites', href: '/prayer-and-rites', Icon: BookOpenWhite },
    { label: 'Learn the Faith', href: '/learn-the-faith', Icon: UsersIcon },

  ];

  const additionalNavItems = [
    { label: 'Favorites', href: '/favorites', Icon: HeartIcon },
    { label: 'Help', href: '#', Icon: HelpIcon },
  ];

  return (

    <div className={sidebarClass}>
      <div className="flex flex-col justify-between w-full h-screen bg-gray-900">
        <div className="">
          <div className="px-3">
            <div className="py-3 pl-3 border-b border-gray-800">
              <img src="/media/images/benlogo.svg" alt="false" className="w-[132px] h-[33px]" />
            </div>
          </div>
          <div className="px-3 pt-6">
            <Navigation items={navigationItems} />
            <div className="border-b border-gray-800"></div>
            <Navigation items={additionalNavItems} classes={'pt-6'} />
          </div>
        </div>

        <div className="px-3">
          <div className="flex flex-row items-center justify-between py-1 pl-3 pr-2 mb-6 bg-gray-800 rounded-lg shadow-custom-shadow">
            <div className="flex flex-col">
              <p className="text-base font-semibold leading-5 text-white-50">Liturgical Day</p>
              <p className="mt-1 text-xs font-normal text-gray-400">May 1, 2024</p>
            </div>
            <div>
              <FishIcon className="text-gray-800" />
            </div>
            <div>
              <div>
                <img src={process.env.PUBLIC_URL + "/media/images/discipline_abstain.svg"} alt="Discipline Abstain" className="w-6 h-6 text-gray-800" />
              </div>
            </div>


          </div>
          <a className="flex flex-row justify-between p-3" href="#">
            {/* <div className="flex flex-row items-center gap-2">
              <div className="flex items-center justify-center w-6 h-6 px-1 py-1 rounded-full bg-gold-500"><span className="font-medium text-[10px] leading-4 text-white-50">AB</span>
              </div>
              <p className="font-medium text-sm leading-4.5 text-white-50">Alexandr Berlinsk</p>
            </div> */}
            <div className="flex flex-row items-center gap-2">
              {/*  ShortName (AB) inside rounded div */}
              <div className="flex items-center justify-center w-6 h-6 px-1 py-1 rounded-full bg-gold-500">
                {isLoading ? (
                  <span className="font-medium text-[10px] leading-4 text-white-50">...</span>
                ) : (
                  <span className="font-medium text-[10px] leading-4 text-white-50">{user.shortName}</span>
                )}
              </div>

              {/*  Full Name (Alexandr Berlinsk) */}
              {isLoading ? (
                <p className="font-medium text-sm leading-4.5 text-white-50">Loading...</p>
              ) : (
                <p className="font-medium text-sm leading-4.5 text-white-50">{user.fullName}</p>
              )}
            </div>

            <span href="#" className="flex items-center">
              <img src="/media/images/shevron-left.svg" alt="shevron left" className="w-4 h-4" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default SidebarLeft;